export const getDayOfTheWeek = (params) => {

    // Create a new Date object
    const currentDate = new Date();

    // Get the day of the week as a number (0-6)
    const dayIndex = currentDate.getDay();

    // Create an array of weekday names
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    // Get the name of the day
    const currentDay = daysOfWeek[dayIndex];

    return currentDay;
};
